import { Stepper, Step, StepLabel, Box, Typography } from "@mui/material";
import { UploadCloud, SquareChevronRight, PlayCircle } from "lucide-react";
import PropTypes from "prop-types";

const steps = [
  {
    label: "Upload an Image",
    desc: "Supported formats: JPG, PNG, Max size: 5MB",
    icon: <UploadCloud size={32} strokeWidth={2} color="#1B5C29" />,
  },
  {
    label: "Write a Prompt",
    desc: "Describe the scene, motion, or context you want in the video.",
    icon: <SquareChevronRight size={32} strokeWidth={2} color="#1B5C29" />,
  },
  {
    label: "Generate Video",
    desc: "Video duration: Up to 10 seconds. Processing may take 15–30 seconds.",
    icon: <PlayCircle size={32} strokeWidth={2} color="#1B5C29" />,
  },
];
function makeStepIconComponent(icon, stepNumber) {
  return function StepIconComponent() {
    return <CustomStepIcon icon={icon} stepNumber={stepNumber} />;
  };
}

function CustomStepIcon({ icon, stepNumber }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: 40,
      }}
    >
      {icon}
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ mt: 0.5 }}
        fontWeight={500}
        fontSize={12}
      >
        {stepNumber}
      </Typography>
    </Box>
  );
}

export default function UploadStepper() {
  return (
    <Stepper
      orientation="vertical"
      activeStep={-1}
      sx={{
        "& .MuiStepConnector-root": {
          ml: "20px",
          borderColor: "#1B5C29",
        },
        "& .MuiStepConnector-line": {
          borderLeftWidth: 2,
          borderColor: "#1B5C29",
        },
      }}
    >
      {steps.map((step, idx) => {
       const StepIconComponent = makeStepIconComponent(step.icon, `Step ${idx + 1}`);

      return (
        <Step key={step.label} active>
          <StepLabel
           StepIconComponent={StepIconComponent}
          >
            <Typography
              variant="subtitle1"
              fontWeight={500}
              color="text.primary"
              fontSize={20}
            >
              {step.label}
            </Typography>
            <Typography
              variant="body2"
              sx={{ mt: 0.5, mb: 1 }}
              fontWeight={500}
              fontSize={14}
            >
              {step.desc}
            </Typography>
          </StepLabel>
        </Step>
      )})}

    </Stepper>
  );
}


CustomStepIcon.propTypes = {
  icon: PropTypes.node.isRequired,
  stepNumber: PropTypes.string.isRequired,
};